/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Menu, Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import router from 'next/router'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect, useState } from 'react'
import DrawRight from '../Category/DrawRight'
import { FilterList } from '../Category/FilterList'

interface ModalFilter {
  setIsOpenDraw: Dispatch<SetStateAction<boolean>>
  isOpenDraw: boolean
  updateParams: (params: any, routerChange?: boolean) => void
  clearFilterParams: () => void
  applyFilterParams: () => void
  activeFilters: {
    name: string
    values: string[]
  }[]
  properties?: Property[]
  categoryMenu: Menu[]
  sortOptions: any
  activeSort: any
  activeSortCustom: string[]
}
const ModalFilter = ({
  setIsOpenDraw,
  isOpenDraw,
  properties,
  updateParams = () => false,
  activeFilters,
  clearFilterParams,
  applyFilterParams,
  sortOptions,
  activeSort = '',
  activeSortCustom = [''],
}: ModalFilter) => {
  const [activeSortButton, setActiveSortButton] = useState('')
  const [, setSelectedValue] = useState<string[]>([])

  const handleClearFilter = () => {
    clearFilterParams()
  }
  const handleApplyFilter = () => {
    applyFilterParams()
    setIsOpenDraw(false)
  }
  useEffect(() => {
    const checkSortActive = sortOptions
      .filter((e: any) => e.type == 'custom')
      .map((item: any) => {
        if (activeSortCustom.includes(item.name)) {
          return item
        }
        return null
      })
      .filter(Boolean)
    setSelectedValue(checkSortActive)
  }, [])
  useEffect(() => {
    if (activeSort) {
      return setActiveSortButton(activeSort)
    }
    return setActiveSortButton('')
  }, [activeSort, router])
  useEffect(() => {
    const element = document.getElementById('activeMn')
    if (element && element.offsetLeft >= 400) {
      document?.getElementById('menuMb')?.scrollTo({
        left: element.offsetLeft - 200,
      })
    }
  })

  const onPriceSort = (name: string) => {
    setActiveSortButton(name)
    if (name == activeSortButton) {
      setActiveSortButton('')
      return updateParams(
        [
          {
            name: 'sortBy',
            value: null,
          },
          {
            name: 'sortType',
            value: null,
          },
        ],
        false
      )
    }
    return updateParams(
      [
        {
          name: 'sortBy',
          value: 'calMediaPrice',
        },
        {
          name: 'sortType',
          value: name,
        },
      ],
      false
    )
  }

  return (
    <DrawRight
      open={isOpenDraw}
      onClose={() => setIsOpenDraw(false)}
      title={'Bộ lọc tìm kiếm'}
      type='filter'
      borderHead={true}
    >
      <div className='cateSideBar pl-3 mr-2 pr-1 h-full max-h-[calc(100svh-160px)] hiddenScrollBar scrollBarXCS overflow-y-auto'>
        {properties &&
          properties.map((e: Property) => {
            return (
              e &&
              e?.values &&
              e?.values?.length > 0 && (
                <FilterList
                  key={e._id}
                  filterGroup={e}
                  activeFilters={activeFilters}
                  onChange={updateParams}
                  className='mb-3'
                  title={getTranslate(e.displayName)}
                />
              )
            )
          })}
        <div className='sort'>
          <div className='title mb-3'>
            <span className='text-sm font-bold text-dark-400'>Sắp xếp</span>
          </div>
          <div className='grid grid-cols-2 mb-8'>
            {sortOptions &&
              sortOptions
                .filter((item: any) => item.type == 'sortType')
                .map((e: any, index: number) => (
                  <div
                    className='w-full bg-white rounded gap-2 pr-5 py-2 form-check-filter box-radio'
                    key={`sort-${index}`}
                  >
                    <input
                      className='form-radio-input'
                      id={e.name}
                      type='radio'
                      defaultChecked={activeSortButton == e.name}
                      name={'shipping-address'}
                      onClick={() => onPriceSort(e.name)}
                    />
                    <label
                      className='form-radio-label w-full flex flex-wrap'
                      htmlFor={e.name}
                    >
                      <span className='block h-full align-super text-sm text-dark-400'>
                        {e.label}
                      </span>
                    </label>
                  </div>
                ))}
          </div>
        </div>
      </div>
      <div className='footerDraw h-[88px] absolute bottom-0 gap-2 bg-white right-0 z-10 w-full shadow-100 pt-4 flex justify-center px-[12%]'>
        <button
          className='rounded-lg border text-primary-base border-primary-base flex h-10 w-full items-center justify-center text-sm uppercase font-semibold'
          onClick={handleClearFilter}
        >
          Bỏ chọn
        </button>
        <button
          className='rounded-lg border text-white bg-primary-base border-primary-base flex h-10 w-full items-center justify-center text-sm uppercase font-semibold'
          onClick={handleApplyFilter}
        >
          Áp dụng
        </button>
      </div>
    </DrawRight>
  )
}

export default ModalFilter
